export default __webpack_public_path__ + "static/media/FF.1e8157ff.png";